export const initialState = () => ({
  stateCountry: "",
  pos: "",
  seller: "",
  captation: "",
  captationName: "",
  wallet: "",
  posCnpj: "",
})
